export default [
  {
    label: "Afar",
    value: "Afar",
  },
  {
    label: "Abkhazian",
    value: "Abkhazian",
  },
  {
    label: "Achinese",
    value: "Achinese",
  },
  {
    label: "Acoli",
    value: "Acoli",
  },
  {
    label: "Adangme",
    value: "Adangme",
  },
  {
    label: "Adyghe Adygei",
    value: "Adyghe Adygei",
  },
  {
    label: "Afro-Asiatic languages",
    value: "Afro-Asiatic languages",
  },
  {
    label: "Afrihili",
    value: "Afrihili",
  },
  {
    label: "Afrikaans",
    value: "Afrikaans",
  },
  {
    label: "Ainu",
    value: "Ainu",
  },
  {
    label: "Akan",
    value: "Akan",
  },
  {
    label: "Akkadian",
    value: "Akkadian",
  },
  {
    label: "Albanian",
    value: "Albanian",
  },
  {
    label: "Aleut",
    value: "Aleut",
  },
  {
    label: "Algonquian languages",
    value: "Algonquian languages",
  },
  {
    label: "Southern Altai",
    value: "Southern Altai",
  },
  {
    label: "Amharic",
    value: "Amharic",
  },
  {
    label: "Angika",
    value: "Angika",
  },
  {
    label: "Apache languages",
    value: "Apache languages",
  },
  {
    label: "Arabic",
    value: "Arabic",
  },
  {
    label: "Official Aramaic (700-300 BCE) Imperial Aramaic (700-300 BCE)",
    value: "Official Aramaic (700-300 BCE) Imperial Aramaic (700-300 BCE)",
  },
  {
    label: "Aragonese",
    value: "Aragonese",
  },
  {
    label: "Armenian",
    value: "Armenian",
  },
  {
    label: "Mapudungun Mapuche",
    value: "Mapudungun Mapuche",
  },
  {
    label: "Arapaho",
    value: "Arapaho",
  },
  {
    label: "Artificial languages",
    value: "Artificial languages",
  },
  {
    label: "Arawak",
    value: "Arawak",
  },
  {
    label: "Assamese",
    value: "Assamese",
  },
  {
    label: "Asturian Bable Leonese Asturleonese",
    value: "Asturian Bable Leonese Asturleonese",
  },
  {
    label: "Athapascan languages",
    value: "Athapascan languages",
  },
  {
    label: "Australian languages",
    value: "Australian languages",
  },
  {
    label: "Avaric",
    value: "Avaric",
  },
  {
    label: "Avestan",
    value: "Avestan",
  },
  {
    label: "Awadhi",
    value: "Awadhi",
  },
  {
    label: "Aymara",
    value: "Aymara",
  },
  {
    label: "Azerbaijani",
    value: "Azerbaijani",
  },
  {
    label: "Banda languages",
    value: "Banda languages",
  },
  {
    label: "Bamileke languages",
    value: "Bamileke languages",
  },
  {
    label: "Bashkir",
    value: "Bashkir",
  },
  {
    label: "Baluchi",
    value: "Baluchi",
  },
  {
    label: "Bambara",
    value: "Bambara",
  },
  {
    label: "Balinese",
    value: "Balinese",
  },
  {
    label: "Basque",
    value: "Basque",
  },
  {
    label: "Basa",
    value: "Basa",
  },
  {
    label: "Baltic languages",
    value: "Baltic languages",
  },
  {
    label: "Beja Bedawiyet",
    value: "Beja Bedawiyet",
  },
  {
    label: "Belarusian",
    value: "Belarusian",
  },
  {
    label: "Bemba",
    value: "Bemba",
  },
  {
    label: "Bengali",
    value: "Bengali",
  },
  {
    label: "Berber languages",
    value: "Berber languages",
  },
  {
    label: "Bhojpuri",
    value: "Bhojpuri",
  },
  {
    label: "Bihari languages",
    value: "Bihari languages",
  },
  {
    label: "Bikol",
    value: "Bikol",
  },
  {
    label: "Bini Edo",
    value: "Bini Edo",
  },
  {
    label: "Bislama",
    value: "Bislama",
  },
  {
    label: "Siksika",
    value: "Siksika",
  },
  {
    label: "Bantu (Other)",
    value: "Bantu (Other)",
  },
  {
    label: "Bosnian",
    value: "Bosnian",
  },
  {
    label: "Braj",
    value: "Braj",
  },
  {
    label: "Breton",
    value: "Breton",
  },
  {
    label: "Batak languages",
    value: "Batak languages",
  },
  {
    label: "Buriat",
    value: "Buriat",
  },
  {
    label: "Buginese",
    value: "Buginese",
  },
  {
    label: "Bulgarian",
    value: "Bulgarian",
  },
  {
    label: "Burmese",
    value: "Burmese",
  },
  {
    label: "Blin Bilin",
    value: "Blin Bilin",
  },
  {
    label: "Caddo",
    value: "Caddo",
  },
  {
    label: "Central American Indian languages",
    value: "Central American Indian languages",
  },
  {
    label: "Galibi Carib",
    value: "Galibi Carib",
  },
  {
    label: "Catalan Valencian",
    value: "Catalan Valencian",
  },
  {
    label: "Caucasian languages",
    value: "Caucasian languages",
  },
  {
    label: "Cebuano",
    value: "Cebuano",
  },
  {
    label: "Celtic languages",
    value: "Celtic languages",
  },
  {
    label: "Chamorro",
    value: "Chamorro",
  },
  {
    label: "Chibcha",
    value: "Chibcha",
  },
  {
    label: "Chechen",
    value: "Chechen",
  },
  {
    label: "Chagatai",
    value: "Chagatai",
  },
  {
    label: "Chinese",
    value: "Chinese",
  },
  {
    label: "Chuukese",
    value: "Chuukese",
  },
  {
    label: "Mari",
    value: "Mari",
  },
  {
    label: "Chinook jargon",
    value: "Chinook jargon",
  },
  {
    label: "Choctaw",
    value: "Choctaw",
  },
  {
    label: "Chipewyan Dene Suline",
    value: "Chipewyan Dene Suline",
  },
  {
    label: "Cherokee",
    value: "Cherokee",
  },
  {
    label:
      "Church Slavic Old Slavonic Church Slavonic Old Bulgarian Old Church Slavonic",
    value:
      "Church Slavic Old Slavonic Church Slavonic Old Bulgarian Old Church Slavonic",
  },
  {
    label: "Chuvash",
    value: "Chuvash",
  },
  {
    label: "Cheyenne",
    value: "Cheyenne",
  },
  {
    label: "Chamic languages",
    value: "Chamic languages",
  },
  {
    label: "Coptic",
    value: "Coptic",
  },
  {
    label: "Cornish",
    value: "Cornish",
  },
  {
    label: "Corsican",
    value: "Corsican",
  },
  {
    label: "Creoles and pidgins",
    value: "Creoles and pidgins",
  },
  {
    label: "Creoles and pidgins",
    value: "Creoles and pidgins",
  },
  {
    label: "Creoles and pidgins",
    value: "Creoles and pidgins",
  },
  {
    label: "Cree",
    value: "Cree",
  },
  {
    label: "Crimean Tatar Crimean Turkish",
    value: "Crimean Tatar Crimean Turkish",
  },
  {
    label: "Creoles and pidgins ",
    value: "Creoles and pidgins ",
  },
  {
    label: "Kashubian",
    value: "Kashubian",
  },
  {
    label: "Cushitic languages",
    value: "Cushitic languages",
  },
  {
    label: "Czech",
    value: "Czech",
  },
  {
    label: "Dakota",
    value: "Dakota",
  },
  {
    label: "Danish",
    value: "Danish",
  },
  {
    label: "Dargwa",
    value: "Dargwa",
  },
  {
    label: "Land Dayak languages",
    value: "Land Dayak languages",
  },
  {
    label: "Delaware",
    value: "Delaware",
  },
  {
    label: "Slave (Athapascan)",
    value: "Slave (Athapascan)",
  },
  {
    label: "Dogrib",
    value: "Dogrib",
  },
  {
    label: "Dinka",
    value: "Dinka",
  },
  {
    label: "Divehi Dhivehi Maldivian",
    value: "Divehi Dhivehi Maldivian",
  },
  {
    label: "Dogri",
    value: "Dogri",
  },
  {
    label: "Dravidian languages",
    value: "Dravidian languages",
  },
  {
    label: "Lower Sorbian",
    value: "Lower Sorbian",
  },
  {
    label: "Duala",
    value: "Duala",
  },
  {
    label: "Dutch",
    value: "Dutch",
  },
  {
    label: "Dutch Flemish",
    value: "Dutch Flemish",
  },
  {
    label: "Dyula",
    value: "Dyula",
  },
  {
    label: "Dzongkha",
    value: "Dzongkha",
  },
  {
    label: "Efik",
    value: "Efik",
  },
  {
    label: "Egyptian (Ancient)",
    value: "Egyptian (Ancient)",
  },
  {
    label: "Ekajuk",
    value: "Ekajuk",
  },
  {
    label: "Elamite",
    value: "Elamite",
  },
  {
    label: "English",
    value: "English",
  },
  {
    label: "Esperanto",
    value: "Esperanto",
  },
  {
    label: "Estonian",
    value: "Estonian",
  },
  {
    label: "Ewe",
    value: "Ewe",
  },
  {
    label: "Ewondo",
    value: "Ewondo",
  },
  {
    label: "Fang",
    value: "Fang",
  },
  {
    label: "Faroese",
    value: "Faroese",
  },
  {
    label: "Fanti",
    value: "Fanti",
  },
  {
    label: "Fijian",
    value: "Fijian",
  },
  {
    label: "Filipino Pilipino",
    value: "Filipino Pilipino",
  },
  {
    label: "Finnish",
    value: "Finnish",
  },
  {
    label: "Finno-Ugrian languages",
    value: "Finno-Ugrian languages",
  },
  {
    label: "Fon",
    value: "Fon",
  },
  {
    label: "French",
    value: "French",
  },
  {
    label: "French",
    value: "French",
  },
  {
    label: "French",
    value: "French",
  },
  {
    label: "Northern Frisian",
    value: "Northern Frisian",
  },
  {
    label: "Eastern Frisian",
    value: "Eastern Frisian",
  },
  {
    label: "Western Frisian",
    value: "Western Frisian",
  },
  {
    label: "Fulah",
    value: "Fulah",
  },
  {
    label: "Friulian",
    value: "Friulian",
  },
  {
    label: "Ga",
    value: "Ga",
  },
  {
    label: "Gayo",
    value: "Gayo",
  },
  {
    label: "Gbaya",
    value: "Gbaya",
  },
  {
    label: "Germanic languages",
    value: "Germanic languages",
  },
  {
    label: "Georgian",
    value: "Georgian",
  },
  {
    label: "German",
    value: "German",
  },
  {
    label: "Geez",
    value: "Geez",
  },
  {
    label: "Gilbertese",
    value: "Gilbertese",
  },
  {
    label: "Gaelic Scottish Gaelic",
    value: "Gaelic Scottish Gaelic",
  },
  {
    label: "Irish",
    value: "Irish",
  },
  {
    label: "Galician",
    value: "Galician",
  },
  {
    label: "Manx",
    value: "Manx",
  },
  {
    label: "German",
    value: "German",
  },
  {
    label: "German",
    value: "German",
  },
  {
    label: "Gondi",
    value: "Gondi",
  },
  {
    label: "Gorontalo",
    value: "Gorontalo",
  },
  {
    label: "Gothic",
    value: "Gothic",
  },
  {
    label: "Grebo",
    value: "Grebo",
  },
  {
    label: "Greek",
    value: "Greek",
  },
  {
    label: "Greek",
    value: "Greek",
  },
  {
    label: "Guarani",
    value: "Guarani",
  },
  {
    label: "Swiss German Alemannic Alsatian",
    value: "Swiss German Alemannic Alsatian",
  },
  {
    label: "Gujarati",
    value: "Gujarati",
  },
  {
    label: "Gwich'in",
    value: "Gwich'in",
  },
  {
    label: "Haida",
    value: "Haida",
  },
  {
    label: "Haitian Haitian Creole",
    value: "Haitian Haitian Creole",
  },
  {
    label: "Hausa",
    value: "Hausa",
  },
  {
    label: "Hawaiian",
    value: "Hawaiian",
  },
  {
    label: "Hebrew",
    value: "Hebrew",
  },
  {
    label: "Herero",
    value: "Herero",
  },
  {
    label: "Hiligaynon",
    value: "Hiligaynon",
  },
  {
    label: "Himachali languages Western Pahari languages",
    value: "Himachali languages Western Pahari languages",
  },
  {
    label: "Hindi",
    value: "Hindi",
  },
  {
    label: "Hittite",
    value: "Hittite",
  },
  {
    label: "Hmong Mong",
    value: "Hmong Mong",
  },
  {
    label: "Hiri Motu",
    value: "Hiri Motu",
  },
  {
    label: "Croatian",
    value: "Croatian",
  },
  {
    label: "Upper Sorbian",
    value: "Upper Sorbian",
  },
  {
    label: "Hungarian",
    value: "Hungarian",
  },
  {
    label: "Hupa",
    value: "Hupa",
  },
  {
    label: "Iban",
    value: "Iban",
  },
  {
    label: "Igbo",
    value: "Igbo",
  },
  {
    label: "Icelandic",
    value: "Icelandic",
  },
  {
    label: "Ido",
    value: "Ido",
  },
  {
    label: "Sichuan Yi Nuosu",
    value: "Sichuan Yi Nuosu",
  },
  {
    label: "Ijo languages",
    value: "Ijo languages",
  },
  {
    label: "Inuktitut",
    value: "Inuktitut",
  },
  {
    label: "Interlingue Occidental",
    value: "Interlingue Occidental",
  },
  {
    label: "Iloko",
    value: "Iloko",
  },
  {
    label: "Interlingua (International Auxiliary Language Association)",
    value: "Interlingua (International Auxiliary Language Association)",
  },
  {
    label: "Indic languages",
    value: "Indic languages",
  },
  {
    label: "Indonesian",
    value: "Indonesian",
  },
  {
    label: "Indo-European languages",
    value: "Indo-European languages",
  },
  {
    label: "Ingush",
    value: "Ingush",
  },
  {
    label: "Inupiaq",
    value: "Inupiaq",
  },
  {
    label: "Iranian languages",
    value: "Iranian languages",
  },
  {
    label: "Iroquoian languages",
    value: "Iroquoian languages",
  },
  {
    label: "Italian",
    value: "Italian",
  },
  {
    label: "Javanese",
    value: "Javanese",
  },
  {
    label: "Lojban",
    value: "Lojban",
  },
  {
    label: "Japanese",
    value: "Japanese",
  },
  {
    label: "Judeo-Persian",
    value: "Judeo-Persian",
  },
  {
    label: "Judeo-Arabic",
    value: "Judeo-Arabic",
  },
  {
    label: "Kara-Kalpak",
    value: "Kara-Kalpak",
  },
  {
    label: "Kabyle",
    value: "Kabyle",
  },
  {
    label: "Kachin Jingpho",
    value: "Kachin Jingpho",
  },
  {
    label: "Kalaallisut Greenlandic",
    value: "Kalaallisut Greenlandic",
  },
  {
    label: "Kamba",
    value: "Kamba",
  },
  {
    label: "Kannada",
    value: "Kannada",
  },
  {
    label: "Karen languages",
    value: "Karen languages",
  },
  {
    label: "Kashmiri",
    value: "Kashmiri",
  },
  {
    label: "Kanuri",
    value: "Kanuri",
  },
  {
    label: "Kawi",
    value: "Kawi",
  },
  {
    label: "Kazakh",
    value: "Kazakh",
  },
  {
    label: "Kabardian",
    value: "Kabardian",
  },
  {
    label: "Khasi",
    value: "Khasi",
  },
  {
    label: "Khoisan languages",
    value: "Khoisan languages",
  },
  {
    label: "Central Khmer",
    value: "Central Khmer",
  },
  {
    label: "Khotanese Sakan",
    value: "Khotanese Sakan",
  },
  {
    label: "Kikuyu Gikuyu",
    value: "Kikuyu Gikuyu",
  },
  {
    label: "Kinyarwanda",
    value: "Kinyarwanda",
  },
  {
    label: "Kirghiz Kyrgyz",
    value: "Kirghiz Kyrgyz",
  },
  {
    label: "Kimbundu",
    value: "Kimbundu",
  },
  {
    label: "Konkani",
    value: "Konkani",
  },
  {
    label: "Komi",
    value: "Komi",
  },
  {
    label: "Kongo",
    value: "Kongo",
  },
  {
    label: "Korean",
    value: "Korean",
  },
  {
    label: "Kosraean",
    value: "Kosraean",
  },
  {
    label: "Kpelle",
    value: "Kpelle",
  },
  {
    label: "Karachay-Balkar",
    value: "Karachay-Balkar",
  },
  {
    label: "Karelian",
    value: "Karelian",
  },
  {
    label: "Kru languages",
    value: "Kru languages",
  },
  {
    label: "Kurukh",
    value: "Kurukh",
  },
  {
    label: "Kuanyama Kwanyama",
    value: "Kuanyama Kwanyama",
  },
  {
    label: "Kumyk",
    value: "Kumyk",
  },
  {
    label: "Kurdish",
    value: "Kurdish",
  },
  {
    label: "Kutenai",
    value: "Kutenai",
  },
  {
    label: "Ladino",
    value: "Ladino",
  },
  {
    label: "Lahnda",
    value: "Lahnda",
  },
  {
    label: "Lamba",
    value: "Lamba",
  },
  {
    label: "Lao",
    value: "Lao",
  },
  {
    label: "Latin",
    value: "Latin",
  },
  {
    label: "Latvian",
    value: "Latvian",
  },
  {
    label: "Lezghian",
    value: "Lezghian",
  },
  {
    label: "Limburgan Limburger Limburgish",
    value: "Limburgan Limburger Limburgish",
  },
  {
    label: "Lingala",
    value: "Lingala",
  },
  {
    label: "Lithuanian",
    value: "Lithuanian",
  },
  {
    label: "Mongo",
    value: "Mongo",
  },
  {
    label: "Lozi",
    value: "Lozi",
  },
  {
    label: "Luxembourgish Letzeburgesch",
    value: "Luxembourgish Letzeburgesch",
  },
  {
    label: "Luba-Lulua",
    value: "Luba-Lulua",
  },
  {
    label: "Luba-Katanga",
    value: "Luba-Katanga",
  },
  {
    label: "Ganda",
    value: "Ganda",
  },
  {
    label: "Luiseno",
    value: "Luiseno",
  },
  {
    label: "Lunda",
    value: "Lunda",
  },
  {
    label: "Luo (Kenya and Tanzania)",
    value: "Luo (Kenya and Tanzania)",
  },
  {
    label: "Lushai",
    value: "Lushai",
  },
  {
    label: "Macedonian",
    value: "Macedonian",
  },
  {
    label: "Madurese",
    value: "Madurese",
  },
  {
    label: "Magahi",
    value: "Magahi",
  },
  {
    label: "Marshallese",
    value: "Marshallese",
  },
  {
    label: "Maithili",
    value: "Maithili",
  },
  {
    label: "Makasar",
    value: "Makasar",
  },
  {
    label: "Malayalam",
    value: "Malayalam",
  },
  {
    label: "Mandingo",
    value: "Mandingo",
  },
  {
    label: "Maori",
    value: "Maori",
  },
  {
    label: "Austronesian languages",
    value: "Austronesian languages",
  },
  {
    label: "Marathi",
    value: "Marathi",
  },
  {
    label: "Masai",
    value: "Masai",
  },
  {
    label: "Malay",
    value: "Malay",
  },
  {
    label: "Moksha",
    value: "Moksha",
  },
  {
    label: "Mandar",
    value: "Mandar",
  },
  {
    label: "Mende",
    value: "Mende",
  },
  {
    label: "Irish",
    value: "Irish",
  },
  {
    label: "Mi'kmaq Micmac",
    value: "Mi'kmaq Micmac",
  },
  {
    label: "Minangkabau",
    value: "Minangkabau",
  },
  {
    label: "Uncoded languages",
    value: "Uncoded languages",
  },
  {
    label: "Mon-Khmer languages",
    value: "Mon-Khmer languages",
  },
  {
    label: "Malagasy",
    value: "Malagasy",
  },
  {
    label: "Maltese",
    value: "Maltese",
  },
  {
    label: "Manchu",
    value: "Manchu",
  },
  {
    label: "Manipuri",
    value: "Manipuri",
  },
  {
    label: "Manobo languages",
    value: "Manobo languages",
  },
  {
    label: "Mohawk",
    value: "Mohawk",
  },
  {
    label: "Mongolian",
    value: "Mongolian",
  },
  {
    label: "Mossi",
    value: "Mossi",
  },
  {
    label: "Multiple languages",
    value: "Multiple languages",
  },
  {
    label: "Munda languages",
    value: "Munda languages",
  },
  {
    label: "Creek",
    value: "Creek",
  },
  {
    label: "Mirandese",
    value: "Mirandese",
  },
  {
    label: "Marwari",
    value: "Marwari",
  },
  {
    label: "Mayan languages",
    value: "Mayan languages",
  },
  {
    label: "Erzya",
    value: "Erzya",
  },
  {
    label: "Nahuatl languages",
    value: "Nahuatl languages",
  },
  {
    label: "North American Indian languages",
    value: "North American Indian languages",
  },
  {
    label: "Neapolitan",
    value: "Neapolitan",
  },
  {
    label: "Nauru",
    value: "Nauru",
  },
  {
    label: "Navajo Navaho",
    value: "Navajo Navaho",
  },
  {
    label: "Ndebele",
    value: "Ndebele",
  },
  {
    label: "Ndebele",
    value: "Ndebele",
  },
  {
    label: "Ndonga",
    value: "Ndonga",
  },
  {
    label: "Low German Low Saxon German",
    value: "Low German Low Saxon German",
  },
  {
    label: "Nepali",
    value: "Nepali",
  },
  {
    label: "Nepal Bhasa Newari",
    value: "Nepal Bhasa Newari",
  },
  {
    label: "Nias",
    value: "Nias",
  },
  {
    label: "Niger-Kordofanian languages",
    value: "Niger-Kordofanian languages",
  },
  {
    label: "Niuean",
    value: "Niuean",
  },
  {
    label: "Norwegian Nynorsk Nynorsk",
    value: "Norwegian Nynorsk Nynorsk",
  },
  {
    label: "Bokmål",
    value: "Bokmål",
  },
  {
    label: "Nogai",
    value: "Nogai",
  },
  {
    label: "Norse",
    value: "Norse",
  },
  {
    label: "Norwegian",
    value: "Norwegian",
  },
  {
    label: "N'Ko",
    value: "N'Ko",
  },
  {
    label: "Pedi Sepedi Northern Sotho",
    value: "Pedi Sepedi Northern Sotho",
  },
  {
    label: "Nubian languages",
    value: "Nubian languages",
  },
  {
    label: "Classical Newari Old Newari Classical Nepal Bhasa",
    value: "Classical Newari Old Newari Classical Nepal Bhasa",
  },
  {
    label: "Chichewa Chewa Nyanja",
    value: "Chichewa Chewa Nyanja",
  },
  {
    label: "Nyamwezi",
    value: "Nyamwezi",
  },
  {
    label: "Nyankole",
    value: "Nyankole",
  },
  {
    label: "Nyoro",
    value: "Nyoro",
  },
  {
    label: "Nzima",
    value: "Nzima",
  },
  {
    label: "Occitan (post 1500) Provençal",
    value: "Occitan (post 1500) Provençal",
  },
  {
    label: "Ojibwa",
    value: "Ojibwa",
  },
  {
    label: "Oriya",
    value: "Oriya",
  },
  {
    label: "Oromo",
    value: "Oromo",
  },
  {
    label: "Osage",
    value: "Osage",
  },
  {
    label: "Ossetian Ossetic",
    value: "Ossetian Ossetic",
  },
  {
    label: "Turkish",
    value: "Turkish",
  },
  {
    label: "Otomian languages",
    value: "Otomian languages",
  },
  {
    label: "Papuan languages",
    value: "Papuan languages",
  },
  {
    label: "Pangasinan",
    value: "Pangasinan",
  },
  {
    label: "Pahlavi",
    value: "Pahlavi",
  },
  {
    label: "Pampanga Kapampangan",
    value: "Pampanga Kapampangan",
  },
  {
    label: "Panjabi Punjabi",
    value: "Panjabi Punjabi",
  },
  {
    label: "Papiamento",
    value: "Papiamento",
  },
  {
    label: "Palauan",
    value: "Palauan",
  },
  {
    label: "Persian",
    value: "Persian",
  },
  {
    label: "Persian",
    value: "Persian",
  },
  {
    label: "Philippine languages",
    value: "Philippine languages",
  },
  {
    label: "Phoenician",
    value: "Phoenician",
  },
  {
    label: "Pali",
    value: "Pali",
  },
  {
    label: "Polish",
    value: "Polish",
  },
  {
    label: "Pohnpeian",
    value: "Pohnpeian",
  },
  {
    label: "Portuguese",
    value: "Portuguese",
  },
  {
    label: "Prakrit languages",
    value: "Prakrit languages",
  },
  {
    label: "Provençal",
    value: "Provençal",
  },
  {
    label: "Pushto Pashto",
    value: "Pushto Pashto",
  },
  {
    label: "Reserved for local use",
    value: "Reserved for local use",
  },
  {
    label: "Quechua",
    value: "Quechua",
  },
  {
    label: "Rajasthani",
    value: "Rajasthani",
  },
  {
    label: "Rapanui",
    value: "Rapanui",
  },
  {
    label: "Rarotongan Cook Islands Maori",
    value: "Rarotongan Cook Islands Maori",
  },
  {
    label: "Romance languages",
    value: "Romance languages",
  },
  {
    label: "Romansh",
    value: "Romansh",
  },
  {
    label: "Romany",
    value: "Romany",
  },
  {
    label: "Romanian Moldavian Moldovan",
    value: "Romanian Moldavian Moldovan",
  },
  {
    label: "Rundi",
    value: "Rundi",
  },
  {
    label: "Aromanian Arumanian Macedo-Romanian",
    value: "Aromanian Arumanian Macedo-Romanian",
  },
  {
    label: "Russian",
    value: "Russian",
  },
  {
    label: "Sandawe",
    value: "Sandawe",
  },
  {
    label: "Sango",
    value: "Sango",
  },
  {
    label: "Yakut",
    value: "Yakut",
  },
  {
    label: "South American Indian (Other)",
    value: "South American Indian (Other)",
  },
  {
    label: "Salishan languages",
    value: "Salishan languages",
  },
  {
    label: "Samaritan Aramaic",
    value: "Samaritan Aramaic",
  },
  {
    label: "Sanskrit",
    value: "Sanskrit",
  },
  {
    label: "Sasak",
    value: "Sasak",
  },
  {
    label: "Santali",
    value: "Santali",
  },
  {
    label: "Sicilian",
    value: "Sicilian",
  },
  {
    label: "Scots",
    value: "Scots",
  },
  {
    label: "Selkup",
    value: "Selkup",
  },
  {
    label: "Semitic languages",
    value: "Semitic languages",
  },
  {
    label: "Irish",
    value: "Irish",
  },
  {
    label: "Sign Languages",
    value: "Sign Languages",
  },
  {
    label: "Shan",
    value: "Shan",
  },
  {
    label: "Sidamo",
    value: "Sidamo",
  },
  {
    label: "Sinhala Sinhalese",
    value: "Sinhala Sinhalese",
  },
  {
    label: "Siouan languages",
    value: "Siouan languages",
  },
  {
    label: "Sino-Tibetan languages",
    value: "Sino-Tibetan languages",
  },
  {
    label: "Slavic languages",
    value: "Slavic languages",
  },
  {
    label: "Slovak",
    value: "Slovak",
  },
  {
    label: "Slovenian",
    value: "Slovenian",
  },
  {
    label: "Southern Sami",
    value: "Southern Sami",
  },
  {
    label: "Northern Sami",
    value: "Northern Sami",
  },
  {
    label: "Sami languages",
    value: "Sami languages",
  },
  {
    label: "Lule Sami",
    value: "Lule Sami",
  },
  {
    label: "Inari Sami",
    value: "Inari Sami",
  },
  {
    label: "Samoan",
    value: "Samoan",
  },
  {
    label: "Skolt Sami",
    value: "Skolt Sami",
  },
  {
    label: "Shona",
    value: "Shona",
  },
  {
    label: "Sindhi",
    value: "Sindhi",
  },
  {
    label: "Soninke",
    value: "Soninke",
  },
  {
    label: "Sogdian",
    value: "Sogdian",
  },
  {
    label: "Somali",
    value: "Somali",
  },
  {
    label: "Songhai languages",
    value: "Songhai languages",
  },
  {
    label: "Sotho",
    value: "Sotho",
  },
  {
    label: "Spanish Castilian",
    value: "Spanish Castilian",
  },
  {
    label: "Sardinian",
    value: "Sardinian",
  },
  {
    label: "Sranan Tongo",
    value: "Sranan Tongo",
  },
  {
    label: "Serbian",
    value: "Serbian",
  },
  {
    label: "Serer",
    value: "Serer",
  },
  {
    label: "Nilo-Saharan languages",
    value: "Nilo-Saharan languages",
  },
  {
    label: "Swati",
    value: "Swati",
  },
  {
    label: "Sukuma",
    value: "Sukuma",
  },
  {
    label: "Sundanese",
    value: "Sundanese",
  },
  {
    label: "Susu",
    value: "Susu",
  },
  {
    label: "Sumerian",
    value: "Sumerian",
  },
  {
    label: "Swahili",
    value: "Swahili",
  },
  {
    label: "Swedish",
    value: "Swedish",
  },
  {
    label: "Classical Syriac",
    value: "Classical Syriac",
  },
  {
    label: "Syriac",
    value: "Syriac",
  },
  {
    label: "Tahitian",
    value: "Tahitian",
  },
  {
    label: "Tai languages",
    value: "Tai languages",
  },
  {
    label: "Tamil",
    value: "Tamil",
  },
  {
    label: "Tatar",
    value: "Tatar",
  },
  {
    label: "Telugu",
    value: "Telugu",
  },
  {
    label: "Timne",
    value: "Timne",
  },
  {
    label: "Tereno",
    value: "Tereno",
  },
  {
    label: "Tetum",
    value: "Tetum",
  },
  {
    label: "Tajik",
    value: "Tajik",
  },
  {
    label: "Tagalog",
    value: "Tagalog",
  },
  {
    label: "Thai",
    value: "Thai",
  },
  {
    label: "Tibetan",
    value: "Tibetan",
  },
  {
    label: "Tigre",
    value: "Tigre",
  },
  {
    label: "Tigrinya",
    value: "Tigrinya",
  },
  {
    label: "Tiv",
    value: "Tiv",
  },
  {
    label: "Tokelau",
    value: "Tokelau",
  },
  {
    label: "Klingon tlhIngan-Hol",
    value: "Klingon tlhIngan-Hol",
  },
  {
    label: "Tlingit",
    value: "Tlingit",
  },
  {
    label: "Tamashek",
    value: "Tamashek",
  },
  {
    label: "Tonga (Nyasa)",
    value: "Tonga (Nyasa)",
  },
  {
    label: "Tonga (Tonga Islands)",
    value: "Tonga (Tonga Islands)",
  },
  {
    label: "Tok Pisin",
    value: "Tok Pisin",
  },
  {
    label: "Tsimshian",
    value: "Tsimshian",
  },
  {
    label: "Tswana",
    value: "Tswana",
  },
  {
    label: "Tsonga",
    value: "Tsonga",
  },
  {
    label: "Turkmen",
    value: "Turkmen",
  },
  {
    label: "Tumbuka",
    value: "Tumbuka",
  },
  {
    label: "Tupi languages",
    value: "Tupi languages",
  },
  {
    label: "Turkish",
    value: "Turkish",
  },
  {
    label: "Altaic languages",
    value: "Altaic languages",
  },
  {
    label: "Tuvalu",
    value: "Tuvalu",
  },
  {
    label: "Twi",
    value: "Twi",
  },
  {
    label: "Tuvinian",
    value: "Tuvinian",
  },
  {
    label: "Udmurt",
    value: "Udmurt",
  },
  {
    label: "Ugaritic",
    value: "Ugaritic",
  },
  {
    label: "Uighur Uyghur",
    value: "Uighur Uyghur",
  },
  {
    label: "Ukrainian",
    value: "Ukrainian",
  },
  {
    label: "Umbundu",
    value: "Umbundu",
  },
  {
    label: "Undetermined",
    value: "Undetermined",
  },
  {
    label: "Urdu",
    value: "Urdu",
  },
  {
    label: "Uzbek",
    value: "Uzbek",
  },
  {
    label: "Vai",
    value: "Vai",
  },
  {
    label: "Venda",
    value: "Venda",
  },
  {
    label: "Vietnamese",
    value: "Vietnamese",
  },
  {
    label: "Volapük",
    value: "Volapük",
  },
  {
    label: "Votic",
    value: "Votic",
  },
  {
    label: "Wakashan languages",
    value: "Wakashan languages",
  },
  {
    label: "Walamo",
    value: "Walamo",
  },
  {
    label: "Waray",
    value: "Waray",
  },
  {
    label: "Washo",
    value: "Washo",
  },
  {
    label: "Welsh",
    value: "Welsh",
  },
  {
    label: "Sorbian languages",
    value: "Sorbian languages",
  },
  {
    label: "Walloon",
    value: "Walloon",
  },
  {
    label: "Wolof",
    value: "Wolof",
  },
  {
    label: "Kalmyk Oirat",
    value: "Kalmyk Oirat",
  },
  {
    label: "Xhosa",
    value: "Xhosa",
  },
  {
    label: "Yao",
    value: "Yao",
  },
  {
    label: "Yapese",
    value: "Yapese",
  },
  {
    label: "Yiddish",
    value: "Yiddish",
  },
  {
    label: "Yoruba",
    value: "Yoruba",
  },
  {
    label: "Yupik languages",
    value: "Yupik languages",
  },
  {
    label: "Zapotec",
    value: "Zapotec",
  },
  {
    label: "Blissymbols Blissymbolics Bliss",
    value: "Blissymbols Blissymbolics Bliss",
  },
  {
    label: "Zenaga",
    value: "Zenaga",
  },
  {
    label: "Zhuang Chuang",
    value: "Zhuang Chuang",
  },
  {
    label: "Zande languages",
    value: "Zande languages",
  },
  {
    label: "Zulu",
    value: "Zulu",
  },
  {
    label: "Zuni",
    value: "Zuni",
  },
  {
    label: "No linguistic content Not applicable",
    value: "No linguistic content Not applicable",
  },
  {
    label: "Zaza Dimili Dimli Kirdki Kirmanjki Zazaki",
    value: "Zaza Dimili Dimli Kirdki Kirmanjki Zazaki",
  },
];
